export default __webpack_public_path__ + "static/feature-merch-c3d2e3bf0c1bbb5031c15e2edd2f472c.png";